import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef, useState, useEffect, useCallback } from "react";
import { EMPTY_STRING, computeNewValueBasedOnUserInput, callOnChangeWithNewValue, isAllowedKey, computeNewValueBasedOnDirection, isLabelShrunk, DEFAULT_STEP } from "./utils/number-input-functions.es.js";
import { CustomNumberSpinner } from "./components/custom-number-spinner.es.js";
import { TextField } from "../text-field/text-field.es.js";
import { CustomArrowButtonDirections } from "./interfaces/custom-arrow-button.interface.es.js";
const NumberInput = forwardRef(function NumberInput2({
  value,
  minValue,
  maxValue,
  disabled,
  onChange,
  step = DEFAULT_STEP,
  ...rest
}, ref) {
  const [currentValue, setCurrentValue] = useState(value ?? EMPTY_STRING);
  const [isFocused, setIsFocused] = useState(false);
  useEffect(function onValuePropChanged() {
    setCurrentValue(value ?? EMPTY_STRING);
  }, [value]);
  const handleInputChange = useCallback(function handleDirectInputFromUser(event) {
    var _a;
    const newValue = computeNewValueBasedOnUserInput({
      newValue: (_a = event.target) == null ? void 0 : _a.value,
      minValue,
      maxValue
    });
    setCurrentValue(newValue);
    callOnChangeWithNewValue(newValue, onChange);
  }, [onChange, minValue, maxValue]);
  const handleKeyDown = useCallback(function handleKeyDown2(event) {
    const pressedKey = event.key;
    if (!isAllowedKey(pressedKey)) {
      event.preventDefault();
    }
  }, [isAllowedKey]);
  const handleArrowButtonClick = useCallback(function updateValueOnArrowButtonClick(direction) {
    const newValue = computeNewValueBasedOnDirection({
      direction,
      value: currentValue,
      step,
      minValue,
      maxValue
    });
    setCurrentValue(newValue);
    callOnChangeWithNewValue(newValue, onChange);
  }, [currentValue, step, minValue, maxValue, onChange]);
  return /* @__PURE__ */ jsx(TextField, { ref, value: currentValue, disabled, inputProps: {
    min: minValue,
    max: maxValue,
    pattern: "[0-9]*",
    inputMode: "numeric",
    onKeyDown: handleKeyDown
  }, InputLabelProps: {
    shrink: isLabelShrunk(currentValue, isFocused)
  }, type: "text", inputMode: "numeric", autoComplete: "off", autoCorrect: "off", maxRows: 1, onFocus: () => {
    setIsFocused(true);
  }, onBlur: () => {
    setIsFocused(false);
  }, onChange: handleInputChange, endIcon: /* @__PURE__ */ jsx(CustomNumberSpinner, { disabled, onUpArrowClick: () => {
    handleArrowButtonClick(CustomArrowButtonDirections.up);
  }, onDownArrowClick: () => {
    handleArrowButtonClick(CustomArrowButtonDirections.down);
  } }), ...rest });
});
export {
  NumberInput
};
//# sourceMappingURL=number-input.es.js.map
